import MainSite from './components/MainSite';
import HomeHeroCarousel from './components/HomeHeroCarousel';
import StandardCarousel from './components/StandardCarousel';
import SimpleCarousel from './components/SimpleCarousel';
import ContactForm from './components/ContactForm';
import StickyButtons from './components/StickyButtons';
import EmailLinks from './components/EmailLinks';
import MobileMenu from './components/MobileMenu';
import LazyLoader from './components/LazyLoader';
export var components = {
  '.main': MainSite,
  '.js-home-hero-carousel': HomeHeroCarousel,
  '.js-standard-carousel': StandardCarousel,
  '.js-simple-carousel': SimpleCarousel,
  '.js-contact': ContactForm,
  '.js-sticky-buttons': StickyButtons,
  '.js-mobile-menu': MobileMenu,
  'a[href^="mailto:"]': EmailLinks,
  '[data-src]': LazyLoader
};